import Swiper from 'swiper'

export class Slider {
  constructor() {
      this.registerSlider()
  }

  registerSlider() {

    const slider = document.querySelectorAll('.slider--slogans')[0]

    /** default config **/
    let config = {
      loop: false,
    }

    /** variables from view **/
    let name = slider.getAttribute('data-slider')
    let per_view = slider.getAttribute('per-view')
    let per_view_sm = slider.getAttribute('per-view-sm')
    let per_view_md = slider.getAttribute('per-view-md')
    let per_view_xs = slider.getAttribute('per-view-xs')
    let modules = slider.getAttribute('modules')

    /** extra config **/
    const extraConfig = slider.getAttribute('extra')

    if (JSON.parse(modules).autoplay) {
      config.autoplay = {
        delay: 2500,
        disableOnInteraction: false,
        waitForTransition: false,
      }
    }

    if (JSON.parse(modules).fade) {
      config.effect = 'fade'
      config.fadeEffect = {
        crossFade: true
      }
    }

    const swiper = new Swiper('.slider--slogans' , {
      ...config,
      ...JSON.parse(extraConfig),
      wrapperClass: name + '-wrapper',
      gap: 20,
      breakpoints: {
        300: {
          slidesPerView: per_view_xs,
        },
        480: {
          slidesPerView: per_view_sm,
        },
        768: {
          slidesPerView: per_view_md,
        },
        1024: {
          slidesPerView: per_view,
        }
      }
    })

  }
}
